


// FAQ Selection Function
function selectFAQ(index) {
    // Remove active class from all question items
    document.querySelectorAll('.faq-question-item').forEach(item => {
        item.classList.remove('active');
    });
    
    // Remove active class from all icons and arrows
    document.querySelectorAll('.faq-question-icon').forEach(icon => {
        icon.classList.remove('active');
    });
    
    document.querySelectorAll('.faq-arrow').forEach(arrow => {
        arrow.classList.remove('active');
    });
    
    document.querySelectorAll('.faq-question-text').forEach(text => {
        text.classList.remove('active');
    });
    
    // Add active class to selected question item
    const selectedItem = document.querySelector(`.faq-question-item:nth-child(${index + 1})`);
    if (selectedItem) {
        selectedItem.classList.add('active');
        selectedItem.querySelector('.faq-question-icon').classList.add('active');
        selectedItem.querySelector('.faq-arrow').classList.add('active');
        selectedItem.querySelector('.faq-question-text').classList.add('active');
    }
    
    // Update the answer content
    const faqData = window.faqsData ? window.faqsData[index] : null;
    if (faqData) {
        document.querySelector('.faq-answer-title').textContent = faqData.name;
        document.querySelector('.faq-answer-text').textContent = faqData.desc;
    }
}



// when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // on .nav-menu-button click
    const io = new IntersectionObserver((entries) =>
         entries.forEach((entry) => {
             // set image source only when it is in the viewport
             if (entry.isIntersecting) {
                 const image = entry.target;
                 // setting image source from the dataset
                 image.src = image.dataset.src;
                 image.style = null;
  
                 // when image is loaded, we do not need to observe it any more
                 io.unobserve(image);
             }
         })
     );
     
     setTimeout(() => {
       document.querySelectorAll('.lazyloaded').forEach(
         (target) => target.classList.add('load')
       );
       document.querySelectorAll(".lazyobs").forEach((element) => io.observe(element));
     }, 2500);
     setTimeout(() => {
       document.querySelectorAll(".banimgdel").forEach((element) => element.classList.add('shown'));
     }, 2600);
  
     const lazyImages = document.querySelectorAll('img.lazyn');
  
     const imageObserver = new IntersectionObserver((entries, observer) => {
         entries.forEach(entry => {
             if (entry.isIntersecting) {
                 const img = entry.target;
                 img.src = img.dataset.src; // Set the src attribute to the data-src value
                 img.style = null;
                 // Load the sources
                 const sources = img.parentElement.querySelectorAll('source');
                 sources.forEach(source => {
                     source.srcset = source.dataset.srcset; // Set the srcset attribute to the data-srcset value
                 });
  
                 img.classList.remove('lazyn'); // Remove the lazy class
                 observer.unobserve(img); // Stop observing the image
             }
         });
     });
  
     lazyImages.forEach(image => {
         setTimeout(() => {
           imageObserver.observe(image); // Start observing each lazy image
         }, 2000);
     });
  
  
  
     
     document.querySelectorAll('.nohash').forEach(function(target){
         target.addEventListener('click', function(e){
             e.preventDefault();
             var hyperLink = this.getAttribute('href');
             var redirectTo = hyperLink.replace('#', '');
             var targetElement = document.getElementById(redirectTo);
             if (targetElement) {
                 targetElement.scrollIntoView({behavior: "smooth"});
             }
         })
     });
     document.querySelectorAll('.prevent').forEach(function(target){
         target.addEventListener('click', function(e){
             e.preventDefault();
             var hyperLink = this.getAttribute('href');
             var redirectTo = hyperLink.replace('#', '');
         })
     });
  
     let navToggle = document.querySelector('.nav-toggle');
     let bars = document.querySelectorAll('.navbar-collapse');
     let headm = document.querySelectorAll('.headn');
     let navbartoggler = document.querySelectorAll('.navbar-toggler');
  
     function toggleHamburger(e) {
       bars.forEach(bar => {
           bar.classList.toggle('show');
         }
       )
       headm.forEach(headm => {
           headm.classList.toggle('hedtoggle');
         }
       )
       navToggle.classList.toggle('toggle');
     }
  
     navToggle.addEventListener('click', toggleHamburger);
  
     
     window.addEventListener( 'resize', () => {
       if ( window.innerWidth < 700 ) {
         document.querySelectorAll('.nvlink').forEach(function(target){
             target.addEventListener('click', function(e){
               // headm.classList.remove('hedtoggle');
               bars.forEach(bar => {
                   bar.classList.toggle('show');
                 }
               )
               headm.forEach(headm => {
                   headm.classList.toggle('hedtoggle');
                 }
               )
               navbartoggler.forEach(navbartoggler => {
                   navbartoggler.classList.toggle('toggle');
                 }
               )
             })
         });
       } else {
         bars.forEach( bar => { bar.classList.remove('show'); } )
         headm.forEach( headm => { headm.classList.remove('hedtoggle'); } )
         navbartoggler.forEach( navbartoggler => { navbartoggler.classList.remove('toggle'); } )
       }
      
     });
     if ( window.innerWidth < 700 ) {
         document.querySelectorAll('.nvlink').forEach(function(target){
             target.addEventListener('click', function(e){
               // headm.classList.remove('hedtoggle');
               bars.forEach(bar => {
                   bar.classList.toggle('show');
                 }
               )
               headm.forEach(headm => {
                   headm.classList.toggle('hedtoggle');
                 }
               )
               navbartoggler.forEach(navbartoggler => {
                   navbartoggler.classList.toggle('toggle');
                 }
               )
             })
         });
       } else {
         bars.forEach( bar => { bar.classList.remove('show'); } )
         headm.forEach( headm => { headm.classList.remove('hedtoggle'); } )
         navbartoggler.forEach( navbartoggler => { navbartoggler.classList.remove('toggle'); } )
     }
     
  
     // let servToggle = document.querySelector('.servitem')
     //  function toggleServitem(e) {
     //   servToggle.classList.remove('active')
     // }
  
     // servToggle.addEventListener('click', toggleServitem);
  
  
     const mousedrag = document.querySelectorAll('.scrolcusto');
     mousedrag.forEach(slider => {
         let mouseDown = false;
         let startX, scrollLeft;
  
         let startDragging = function (e) {
           mouseDown = true;
           startX = e.pageX - slider.offsetLeft;
           scrollLeft = slider.scrollLeft;
         };
         let stopDragging = function (e) {
           mouseDown = false;
         };
  
         slider.addEventListener('mousemove', (e) => {
           e.preventDefault();
           if(!mouseDown) { return; }
           const x = e.pageX - slider.offsetLeft;
           const scroll = x - startX;
           slider.scrollLeft = scrollLeft - scroll;
         });
         // Add the event listeners
         slider.addEventListener('mousedown', startDragging, false);
         slider.addEventListener('mouseup', stopDragging, false);
         slider.addEventListener('mouseleave', stopDragging, false);
     });
  
     // var classtarget = document.querySelectorAll('.revitem');
     // function moveIt() {
     //   var innerDiv = document.getElementsByClassName("rem")[0];
     //   var classn = document.getElementsByClassName("revshow")[0];
     //   var outerDiv = innerDiv.parentElement;
  
     //   if (outerDiv.nextElementSibling != null) {
     //     outerDiv.nextElementSibling.classList.add('revshow'); 
     //     outerDiv.classList.remove('revshow');
     //     outerDiv.nextElementSibling.appendChild(outerDiv.removeChild(innerDiv));
     //   } else {
     //     outerDiv.parentElement.firstElementChild.appendChild(
     //       outerDiv.removeChild(innerDiv)
     //     );
     //     outerDiv.classList.remove('revshow');
     //     outerDiv.parentElement.firstElementChild.classList.add('revshow');
         
     //   }
     // }
     // setInterval(function() {
     //   moveIt();
     // }, 2 * 1000);
  
     const accordions = document.querySelectorAll(".accordion");
     const openAccordion = (accordion) => {
       const content = accordion.querySelector(".accordion__content");
       accordion.classList.add("accordion__active");
       content.style.maxHeight = content.scrollHeight + "px";
     };
  
     const closeAccordion = (accordion) => {
       const content = accordion.querySelector(".accordion__content");
       accordion.classList.remove("accordion__active");
       content.style.maxHeight = null;
     };
  
     accordions.forEach((accordion) => {
       const intro = accordion.querySelector(".accordion__intro");
       const content = accordion.querySelector(".accordion__content");
  
       intro.onclick = () => {
         if (content.style.maxHeight) {
           closeAccordion(accordion);
         } else {
           accordions.forEach((accordion) => closeAccordion(accordion));
           openAccordion(accordion);
         }
       };
     });
  
     // const accordionservli = document.querySelectorAll(".servitem");
     // accordionservli.forEach((accordion,i) => { 
     //   const intro2 = accordion.querySelector(".servtoggle");
     //   intro2.addEventListener("click", () => { 
     //       accordion.classList.toggle("active"); 
     //       // let description = accordion.querySelector(".descrtp"); 
     //       // if(accordion.classList.contains("active")){ 
     //       // }else{ 
     //       // } 
     //       removeExistClass(i);  
     //   });
     // });
    
     function removeExistClass(i){ 
         accordionwhyli.forEach((accodn,ii)=>{ 
             if(i != ii){ 
                 accodn.classList.remove("activen"); 
             } 
         }) 
     }
  
     
  
     const vid = document.getElementById("vidpla");
     const iconsound = document.querySelectorAll(".iconsound");
  
     iconsound.forEach((iconsoundn,i) => { 
         iconsoundn.addEventListener("click", () => {
             iconsoundn.classList.toggle("active");
             if (vid.muted === false) {    
                   vid.muted = true;
             }
             else {
               vid.muted = false;
             }
         });
     });
    
     
   
     // define an observer instance
     var observer = new IntersectionObserver(onScrolIntersection, {
       root: null, // default is the viewport
       threshold: 0.4, // percentage of taregt's visible area."
     });
     
     // callback is called on intersection change
     function onScrolIntersection(entries, opts) {
       entries.forEach((entry) => {
         // console.log(entry);
         if(entry.isIntersecting) {
           entry.target.classList.add('anim');
         } else {
           entry.target.classList.remove('anim');
         }
       });
     }
     // Use the bserver to observe an element
     // observer.observe(document.querySelector(".setlist"));
  
  
     let scrollpos = window.scrollY
     const header = document.querySelector("header");
     const header_height = header.clientHeight - 10;
    
     
     
     window.addEventListener('scroll', function(e) { 
      
       scrollpos = window.scrollY;
  
       // console.log(slindx1_height, slindx2_height);
  
       if (scrollpos > header_height) {
         header.classList.add("scrolin");
         setTimeout(() => {
           header.classList.add("htop");
         }, 50);
       }
       else {
         header.classList.remove("scrolin");
         header.classList.remove("scrolledUp");
         setTimeout(() => {
           header.classList.remove("htop");
         }, 50);
       }
     
       if (scrollpos >= header_height) { header.classList.add("active"); }
       else { header.classList.remove("active"); }
  
    
     })
  
     
     
     document.querySelectorAll(".cformpop").forEach(function (e) {
       e.addEventListener("click", function (e) {
         e.preventDefault(),
           document.body.classList.add("noscrol"),
           document.getElementById("contact").classList.add("ntop"),
           setTimeout(() => {
             document.getElementById("contact").classList.add("position-fixed")
           }
             , 50)
       })
     });
     document.querySelectorAll(".cformclose").forEach(function(e) {
         e.addEventListener("click", function(e) {
             e.preventDefault(),
             document.getElementById("contact").classList.remove("position-fixed"),
             document.body.classList.remove("noscrol"),
             setTimeout( () => {
                 document.getElementById("contact").classList.remove("ntop")
             }
             , 500)
         })
     });
     
  
   
     
     // initialize();
  
     // document.querySelectorAll('.inputfrm').forEach(function(target){
     //     const isEmpty = str => !str.trim().length;
     //     target.addEventListener("input", function() {
     //       if( isEmpty(this.value) ) {
     //         target.parentElement.classList.add('error');
     //         target.parentElement.classList.remove('notempty');
     //       } else {
     //         target.parentElement.classList.remove('error');
     //         target.parentElement.classList.add('notempty');
     //       }
     //     });
     // });
  
  
     document.querySelectorAll('.title').forEach(function(target){
         target.addEventListener('click', function(e){
           target.parentElement.parentElement.classList.toggle('show')
         })
     });
  
     document.querySelectorAll('.cformnall').forEach(function(target){
         var errorElementAll = document.getElementById('errorform');
  
         target.addEventListener('submit', function(event){
             // Prevent form submission
         event.preventDefault();
         // Clear previous error messages
         clearErrors();
         // Validate the form
         let isValid = true;
         // Get all input elements in the form
         const inputs = this.querySelectorAll('.required');
         inputs.forEach(input => {
             const value = input.value.trim();
             const errorElement = document.getElementById(input.id + 'Error');
             // Check if the field is empty
             if (value === '') {
                 showError(errorElement, 'This field is required.');
                 input.classList.add("berror");
                 input.parentNode.classList.add('erron');
  
                 isValid = false;
                 return; // Skip to the next input
             }
             // Additional validation based on input type
             if (input.type === 'email') {
                 const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                 if (!emailPattern.test(value)) {
                     showError(errorElement, 'Please enter a valid email address.');
                     isValid = false;
                 }
             }
             if (input.type === 'tel') {
                 // const phonePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
               // var phonePattern = /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/;
               var phonePattern = /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/;
               // const phonePatternempty = /^0\d{9}$/;
                 if (!phonePattern.test(value)) {
                     showError(errorElement, 'Invalid phone number. No spaces');
                     isValid = false;
                 }
             }
         });
  
         // If the form is valid, you can submit it or perform other actions
         if (isValid) {
           const formData = new FormData(this);
           // document.querySelector(".inputnamval").style.opacity = 0;
           // document.querySelector(".inputnamval").disabled = true;
           // document.querySelector(".spinner-border").style.display = 'block';
           // AJAX request
           fetch('src/form.php', {
               method: 'POST',
               body: formData
           })
           .then(response => {
               if (!response.ok) {
                   throw new Error('Network response was not ok');
               }
               return response.json();
           })
           .then(data => {
               // console.log(data);
               if(data.redirect) {
                 setTimeout(() => {
                   window.location.href = data.location;
                 }, 1000);
               }
               else {
                 // alert(data.message);
                 showErrorAll(errorElementAll, data.message);
               }
  
           })
           .catch(error => {
               // document.querySelector(".inputnamval").style.opacity = 1;
               // setTimeout(() => {
               //   document.querySelector(".inputnamval").disabled = false;
               // }, 500);
               // document.querySelector(".spinner-border").style.display = 'none';
               // alert('There was a problem with the fetch operation:', error);
               showErrorAll(errorElementAll, 'There was a problem with the fetch operation:', error);
           });
         }
         })
     });

     (function() {
        const img1 = document.querySelector('#whyimg-switcher .img1');
        const img2 = document.querySelector('#whyimg-switcher .img2');
        let swapped = false;
        
        setInterval(() => {
            if (!swapped) {
                // Move img1 to right and rotate clockwise
                img1.style.left = '40%';
                img1.style.top = '20px';
                img1.style.transform = 'rotate(5deg)';
                img1.style.zIndex = '1';
                
                // Move img2 to left and rotate counter-clockwise
                img2.style.left = '0';
                img2.style.top = '-30px';
                img2.style.transform = 'rotate(-5deg)';
                img2.style.zIndex = '2';
            } else {
                // Move img1 back to left and rotate counter-clockwise
                img1.style.left = '0';
                img1.style.top = '0';
                img1.style.transform = 'rotate(-5deg)';
                img1.style.zIndex = '2';
                
                // Move img2 back to right and rotate clockwise
                img2.style.left = '40%';
                img2.style.top = '-40px';
                img2.style.transform = 'rotate(5deg)';
                img2.style.zIndex = '1';
            }
            swapped = !swapped;
        }, 4000);
    })();

    const pritems = document.querySelectorAll('.pritem');
    const pritemsWrap = document.querySelector('.projects-wrap');

    // Helper: Remove prhover from all, add to one
    function setActivePritem(activeIdx) {
        pritems.forEach((pritem, idx) => {
            if (idx === activeIdx) {
                pritem.classList.add('prhover');
            } else {
                pritem.classList.remove('prhover');
            }
        });
    }

    // On mouseenter of a pritem, only that one gets prhover
    pritems.forEach((pritem, idx) => {
        pritem.addEventListener('mouseenter', (e) => {
            setActivePritem(idx);
            e.stopPropagation();
        });
    });

    // On mouseleave of the whole projects-wrap, reset to first
    pritemsWrap.addEventListener('mouseleave', () => {
        setActivePritem(0);
    });

    // On page load, ensure first is active
    setActivePritem(0);

    // Enhance selectFAQ to update mobile answer visibility
      function selectFAQ(index) {
        // Remove 'active' from all
        document.querySelectorAll('.faq-question-item').forEach(function(item, i) {
            item.classList.toggle('active', i === index);
        });

        // Update right panel (desktop)
        if (window.faqsData && window.faqsData[index]) {
            var answerContent = document.querySelector('.faq-answer-content');
            if (answerContent) {
                answerContent.querySelector('.faq-answer-title').textContent = window.faqsData[index].name;
                answerContent.querySelector('.faq-answer-text').textContent = window.faqsData[index].desc;
            }
        }
    }
    
  
     AOS.init();
     let scrollRef = 0;
     window.addEventListener('resize', () => {
       // increase value up to 10, then refresh AOS
       scrollRef <= 10 ? scrollRef++ : AOS.refresh();
     });
  
    
  
  });
  
  
  
  
  
  
  function showError(errorElement, message) {
   errorElement.textContent = message;
  }
  function showErrorAll(errorElement, message) {
   errorElement.innerHTML  = '<div class="erronall"><span>'+message+'</span></div>';
   const yOffset = -300; 
   
   const errorform = document.getElementById('errorform');
   const y = errorform.getBoundingClientRect().top + window.scrollY + yOffset;
   // errorform.scrollIntoView({behavior: "smooth"});
   window.scrollTo({top: y, behavior: 'smooth'});
  
  }
  function clearErrors() {
   const errorElements = document.querySelectorAll('.frmerror');
   const errorElements2 = document.querySelectorAll('.berror');
   const errorElements3 = document.querySelectorAll('.erronall');
   errorElements.forEach(element => {
       element.textContent = '';
   });
   errorElements2.forEach(element => {
       element.classList.remove('berror');
   });
   errorElements3.forEach(element => {
       element.remove();
   });
  }
  
  
  const slider = '.servicessli';
  const adrmclas = document.getElementById('servicessli');
  
  const BREAKPOINTS = { phone: 991 };
  
  function initSlider() {
  let glideInit = false;
  
  const options = {
    type: 'carousel',
    rewind: false,
    bound: true,
    perView: 3,
    breakpoints: {
      991: {
        perView: 2,
        peek: {
          before: 0,
          after: 150
        },
      },
      700: {
        perView: 2,
        peek: {
          before: 0,
          after: 50,
        },
      },
      600: {
        perView: 1,
        gap: 5,
        peek: {
          before: 0,
          after: 210,
        },
      },
      540: {
        perView: 1,
        gap: 5,
        peek: {
          before: 0,
          after: 170,
        },
      },
      440: {
        perView: 1,
        gap: 5,
        peek: {
          before: 0,
          after: 100,
        },
      },
     },
  };
  
  
  
  // Starts if mobile
  let glide = new Glide( slider, options );
  
  if ( window.innerWidth < BREAKPOINTS.phone ) {
   glide.mount();
   glideInit = true;
   adrmclas.classList.remove('nodesk');
  
  }
  
  
  // On resize, if phone mount else destroy
  window.addEventListener( 'resize', () => {
   if ( window.innerWidth < BREAKPOINTS.phone ) {
     if ( glideInit === false ) {
       glide = new Glide( slider, options );
       glide.mount();
       glideInit = true;
       adrmclas.classList.remove('nodesk');
  
      
     }
   } else {
     if ( glideInit === true ) {
       glide.destroy();
       glideInit = false;
       adrmclas.classList.add('nodesk');
      
     }
   }
   
  });
  };
  initSlider();
  
var sglide = {
  type: 'carousel',
  perView: 2,
  focusAt: 1,
  autoplay: 3000,
  rewind: false,
  bound: true,
  gap: 10,
  peek: {
   before: 0,
   after: 150
  },
  breakpoints: {
   1600: {
     perView: 2,
     gap: 10,
     peek: {
       before: 0,
       after: 200
     },
   },
   1400: {
     perView: 2,
     gap: 10,
     peek: {
       before: 0,
       after: 100
     },
   },
   1200: {
     perView: 2,
     gap: 10,
     peek: {
       before: 0,
       after: 100
     },
   },
   991: {
     perView: 3,
     gap: 10,
     peek: {
       before: 0,
       after: 0
     },
   },
   812: {
     perView: 2,
     gap: 10,
     peek: {
       before: 0,
       after: 50
     },
   },
   700: {
     perView: 1,
     gap: 10,
     peek: {
       before: 0,
       after: 200,
     },
   },
   600: {
     perView: 1,
     gap: 0,
     peek: {
       before: 0,
       after: 220,
     },
   },
   540: {
    perView: 1,
    gap: 10,
    peek: {
      before: 0,
      after: 180,
      },
    },
    440: {
    perView: 1,
    gap: 10,
    peek: {
      before: 0,
      after: 150,
      },
    },
  },
}
var inst = new Glide('#banhighlight', sglide).mount();

var sglide2 = {
  type: 'carousel',
  perView: 5,
  focusAt: 'center',
  autoplay: 3000,
  rewind: false,
  bound: true,
  gap: 0,
  breakpoints: {
   1600: {
     perView: 3,
     gap: 10,
   },
   1400: {
     perView: 3,
     gap: 10,
   
   },
   1200: {
     perView: 3,
     gap: 10,
   
   },
   991: {
     perView: 2,
     gap: 10,
     
   },
   812: {
     perView: 2,
     gap: 10,
   
   },
   700: {
     perView: 2,
     gap: 10,
   
   },
   600: {
     perView: 1,
     gap: 0,
   
   },
  },
}
var inst2 = new Glide('#tilinglsli', sglide2);

// Add transform: scale(1) to .img-item in the active slide
inst2.on(['mount.after', 'run.after'], function() {
  // Remove scale(1) from all slides first
  var slides = document.querySelectorAll('#tilinglsli .glide__slide .img-item');
  slides.forEach(function(item) {
    item.style.transform = 'scale(.92)';
    item.style.opacity = '0.4';
  });
  // Add scale(1) to active slides
  var activeSlides = document.querySelectorAll('#tilinglsli .glide__slide.glide__slide--active .img-item');
  activeSlides.forEach(function(item) {
    item.style.transform = 'scale(1.1)';
    item.style.opacity = '1';
  });
});

inst2.mount();

var sglide3 = {
  type: 'carousel',
  perView: 3,
  rewind: false,
  bound: true,
  gap: 0,
  breakpoints: {
   1600: {
     perView: 3,
   },
   1400: {
     perView: 3,
   
   },
   1200: {
     perView: 2,
     gap: 10,
   
   },
   991: {
     perView: 2,
     gap: 10,
     
   },
   812: {
     perView: 2,
     gap: 10,
   
   },
   700: {
     perView: 1,
     gap: 10,
   
   },
   540: {
     perView: 1,
     gap: 0,
   
   },
  },
}
var inst3 = new Glide('#reviewssli', sglide3).mount();
 